import { AbstractPmsApiService } from "./abstract.service";

export class AbstractDownloadableService extends AbstractPmsApiService {

    /**
     * @param {$http} http
     * @param {ConfigPmsApiService} config
     * @param {EventsBrokerPmsApiService} eventsBroker
     */
    constructor(http, config, eventsBroker, $injector, $window) {
        super(http, config, eventsBroker, $injector);
        this.$window = $window;
    }

    /**
     * @type {string[]}
     */
    static get $inject() {
        const parentInject = AbstractPmsApiService.$inject || ['$http', 'ConfigPmsApiService', 'EventsBrokerPmsApiService'];
        return [...parentInject, '$window'];
    }

    /**
     * @param {string} url
     * @param {string} name
     * @returns {Promise}
     */
    fetch(url, name = 'file.txt') {
        return this.fetchFile(url, name);
    }

    /**
     * @param {string} url
     * @param {object} params
     * @param {string} name
     * @returns {Promise}
     */
    download(url, params, name = 'file.txt') {
        return this.http
            .post(url, params, {
                headers: this.authHeaders,
                responseType: 'blob',
            })
            .then((response) => {
                this.downloadAsBlob(response.data, name);
            })
            .catch(this.getErrorHandler());
    }

    // === Methods imported from DownloadFile ===

    fetchFile(url, name = null) {
        const dataService = url => fetch(url, {
            method: 'GET',
            headers: this.authHeaders,
        });

        return dataService(url)
            .then(response => {
                if (response.status < 200 || response.status >= 400) {
                    return Promise.reject({status: response.status, data:response.json()})
                }

                return response;
            })
            .then(response => response.blob())
            .then(data => {
                this.downloadAsBlob(data, name);
            })
            .catch(this.getErrorHandler());
    }

    downloadAsBlob(data, name = null) {
        const blob = new Blob([data], {type: data.type || 'application/octet-stream'});
        
        // Use URL or webkitURL if available
        const URL = window.URL || window.webkitURL || {};
        
        if (!URL.createObjectURL) {
            console.error('Browser does not support URL.createObjectURL');
            return;
        }
        
        const url = URL.createObjectURL(blob);
        // Use downloadUrl instead of download to avoid method collision
        this.downloadUrl(url, name);
        URL.revokeObjectURL(url);
    }

    downloadUrl(url, name = null) {
        //iOS devices do not support downloading. We have to inform user about this.
        if (/(iP)/g.test(window.navigator.userAgent)) {
            window.open(url, '_blank');
            return false;
        }

        //If in Chrome or Safari - download via virtual link click
        if (this.isEverGreen()) {
            const link = window.document.createElement('a');
            link.href = url;
            if (this.isChrome() || this.isSafari()) {
                link.setAttribute('target', '_blank');
            }

            if (angular.isDefined(link.download)) {
                link.download = name || url.substring(url.lastIndexOf('/') + 1, url.length);
            }

            if (window.document.createEvent) {
                const e = window.document.createEvent('MouseEvents');
                e.initEvent('click', true, true);
                link.dispatchEvent(e);
                return true;
            }
        }

        window.open(url, '_blank');
        return true;
    }

    isEverGreen() {
        return [
            this.isChrome(),
            this.isSafari(),
            this.isFirefox(),
        ].some(isBrowser=> isBrowser);
    }

    isChrome() {
        return this.isBrowser('chrome');
    }

    isSafari() {
        return this.isBrowser('safari');
    }

    isFirefox() {
        return this.isBrowser('mozilla');
    }

    isBrowser(tag) {
        return window.navigator.userAgent.toLowerCase().indexOf(tag) > -1;
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/abstract-downloadable.service.js